<template>
  <div class="not-available">
    <h2>{{ $t('web.reward_unavailable.unavailable') }}</h2>
    <div class="links">
      <router-link :to="{name: 'Rewards'}">
        {{ $t('web.reward_unavailable.rewards_list_link') }}
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'not-available'
}
</script>

<style lang="sass" scoped>
.not-available
  text-align: center
</style>



// WEBPACK FOOTER //
// RewardUnavailable.vue?a0c09140